import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import {cloneDeep} from 'lodash';
import {modifyPageLayoutComponents} from '../PageLayout';

import template from './purchase.rt';
import packageConfirmationTemplate from './packageConfirmation.rt';
import paymentTypeInfoTemplate from './paymentTypeInfo.rt';
import thankYouTemplate from './thankYou.rt';

import {goToNextStep, loadSubscriptions, selectSubscriptionGroup, updatePaymentInfo, performPayment,
  selectSubscription} from "./purchaseActions";
import * as misc from "../../misc";
import {messageBoxEx_Show} from "../../actions";

const mapStateToProps = state => {
  const {purchase} = state;
  return {
    purchase
  }
};

const mapDispatchToProps = dispatch => {
  return {
    selectSubscriptionGroup: groupName => dispatch(selectSubscriptionGroup(groupName)),
    goToNextStep: () => dispatch(goToNextStep()),
    loadSubscriptions: fabricatorId => dispatch(loadSubscriptions(fabricatorId)),
    messageBoxEx_Show: (show, type, title, message, buttons) => dispatch(messageBoxEx_Show(show, type, title, message, buttons)),
    updatePaymentInfo: paymentInfo => dispatch(updatePaymentInfo(paymentInfo)),
    performPayment: paymentInfo => dispatch(performPayment(paymentInfo)),
    selectSubscription: (groupName, subscription) => dispatch(selectSubscription(groupName, subscription))
  }
};

class Purchase extends Component {

  constructor(props) {
    super(props);

    this.state = {
      paymentInfo: cloneDeep(this.props.purchase.paymentInfo)
    }
  }

  componentDidMount() {
    document.documentElement.classList.add("pricing-page");
    document.body.classList.add("pricing-page");

    const params = misc.parseQuery();
    const fabricatorId = +(params['fabid'] || params['fabricatorid']);
    const service = params['service'];
    if (!fabricatorId) {
      this.props.messageBoxEx_Show(true, 'error', 'Error', 'Sorry but a wrong URL was opened. Missing fabricator. Please contact Quote Countertops.');
      return ;
    }
    if (service !== 'kitchen' && service !== 'bathroom') {
      this.props.messageBoxEx_Show(true, 'error', 'Error', 'Sorry but a wrong URL was opened. Missing service. Please contact Quote Countertops.');
      return ;
    }

    this.fabricatorId = fabricatorId;
    this.service = service;
    this.props.loadSubscriptions(this.fabricatorId);
  }

  componentWillUnmount(){
    document.documentElement.classList.remove("pricing-page");
    document.body.classList.remove("pricing-page");
  }

  submitPayment = () => {
    const {paymentInfo} = this.state;
    let errors = misc.validateCCInfo({
      name: paymentInfo.name,
      number: paymentInfo.ccNum,
      expYear: paymentInfo.expYear,
      expMonth: paymentInfo.expMonth,
      cvv: paymentInfo.cvv
    });

    if (!paymentInfo.country.zipCodeRg.test(paymentInfo.zipCode)) {
      errors.push(`Invalid zip code provided for country ${paymentInfo.country.name}.`);
    }

    if (errors.length) {
      this.props.messageBoxEx_Show(true, 'error', 'Invalid/Missing credit card information', errors.join('<br />'));
      return ;
    }

    this.props.updatePaymentInfo(paymentInfo);
    const serverData = {
      ...paymentInfo,
      fabricatorId: this.fabricatorId,
      subscriptionId: this.props.purchase.selectedSubscription.id,
      service: this.service
    };
    serverData.country = paymentInfo.country.name;

    this.props.performPayment(serverData);
  }

  setPaymentInfo = (e, propName) => {
    this.state.paymentInfo[propName] = e.target.value;
    this.setState({paymentInfo: this.state.paymentInfo});
  }

  selectCountry = country => {
    this.state.paymentInfo.country = country;
    this.setState({paymentInfo: this.state.paymentInfo});
  }

  goToDashboard = () => {
    location.href= '/dashboard';
  }

  subscriptionKey = sub => sub.id;

  subscriptionValue = sub => sub.period;

  countryKey = c => c.name;

  render() {
    const {step} = this.props.purchase;
    switch (step) {
      case 2:
        return packageConfirmationTemplate.apply(this);
      case 3:
        return paymentTypeInfoTemplate.apply(this);
      case 4:
        return thankYouTemplate.apply(this);
      default:
        return template.apply(this);
    }
  }
}

const connector = connect(mapStateToProps, mapDispatchToProps);

export default modifyPageLayoutComponents({
  content: connector(Purchase)
});

Purchase.propTypes = {
  pricing: PropTypes.object.isRequired,

  selectSubscriptionGroup: PropTypes.func.isRequired,
  goToNextStep: PropTypes.func.isRequired,
  loadSubscriptions: PropTypes.func.isRequired,
  messageBoxEx_Show: PropTypes.func.isRequired,
  updatePaymentInfo: PropTypes.func.isRequired,
  performPayment: PropTypes.func.isRequired
}
